import HexController from 'controllers/hex_controller'

export default class extends HexController {
  static targets = ['usage', 'script'];

  toggleUsage(e) {
    e.preventDefault();
    this.usageTarget.classList.toggle('hidden')
    this.scriptTarget.classList.toggle('hidden')
  }
}